/**
 * Created by portiz on 8/15/2018.
 */
import React from 'react';

/**
 * The generic barchart. Requires react-chartjs
 */
class BarChart extends React.Component {

    constructor(props){
        // Super is always called when definiting the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);
        this.data = props.data.triesChartData;
    }

    /**
     * This handles every time we update the chart
     * @param props
     */
    componentWillReceiveProps(props){
        this.data =  props.data.triesChartData;
    }

    /**
     * Renders the component
     * @returns {XML}
     */
    render(){
        // Specify the chart you want to try
        let BarChart = require("react-chartjs").Bar;

        // The options
        let options = {
            segmentShowStroke : true,

            //String - The colour of each segment stroke
            segmentStrokeColor : "#fff",

            //Number - The width of each segment stroke
            segmentStrokeWidth : 2,

            //Number - The percentage of the chart that we cut out of the middle
            percentageInnerCutout : 25, // This is 0 for Pie charts

            //Number - Amount of animation steps
            animationSteps : 100,

            //String - Animation easing effect
            animationEasing : "easeOutBounce",

            //Boolean - Whether we animate the rotation of the Doughnut
            animateRotate : true,

            //Boolean - Whether responsive or not
            responsive: true
        };

        return (
            <BarChart data={this.data} options={options} width={600} height={250}/>
        );
    }
}
export default BarChart;


// WEBPACK FOOTER //
// ./src/components/charts/chart-bar.js